import React from "react";
import {
  Container,
  Content,
  ImageContainer,
  Tag,
  Title,
  Meta,
  MetaSeparator,
  MetaSpan,
} from "./styles";
import { calcReadTime, displayDateShort } from "../../../lib/utils";

function ArticleCard({ inHeader = false, data, onClick, openBlogsByTag }) {
  return (
    <Container id={`blog-${data.id}`} $inHeader={inHeader}>
      <ImageContainer>
        <img src={data.heroImage} alt="Illustration" />
        <Tag onClick={openBlogsByTag}>{data.tag}</Tag>
      </ImageContainer>
      <Content>
        <Title $inHeader={inHeader} onClick={onClick}>
          {data.title}
        </Title>
        <Meta>
          <MetaSpan>
            <img src="/images/icons/blog-calendar.svg" alt="calendar" />
            {displayDateShort(data.publishDate)}
          </MetaSpan>
          <MetaSeparator />
          <MetaSpan>
            <img src="/images/icons/blog-clock.svg" alt="clock" />
            {calcReadTime(data.text)} min read
          </MetaSpan>
        </Meta>
      </Content>
    </Container>
  );
}

export default ArticleCard;
